let tel = /^[1][3,4,5,6,7,8,9][0-9]{9}$/; //手机号码
// 电话号码的验证
var Tel = (rule, value, callback) => {
  if (!tel.test(value)) {
    callback(new Error('请正确填写电话号码'));
  } else {
    callback();
  }
};
export default {
  label: '登记',
  icon: 'el-icon-warning',
  submitText: '保存',
  emptyBtn: false,
  column: [
    {
      label: '登记日期',
      span: 8,
      size: 'small',
      type: 'datetime',
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
      prop: 'time',
      disabled: true,
    },
    {
      type: 'input',
      label: '登记人',
      span: 8,
      display: true,
      size: 'small',
      prop: 'userName',
      disabled: true,
    },
    {
      type: 'input',
      label: '反映人',
      span: 8,
      display: true,
      size: 'small',
      prop: 'repairEmp',
      maxlength: 10,
      showWordLimit: true,
      rules: [
        {
          required: true,
          message: '反映人必须填写',
        },
      ],
    },
    {
      type: 'input',
      label: '联系电话',
      span: 8,
      display: true,
      size: 'small',
      prop: 'repairPhone',
      maxlength: 11,
      showWordLimit: true,
      rules: [
        {
          required: true,
          message: '联系电话必须填写',
        },
        {
          validator: Tel,
          message: '联系电话格式不匹配',
          trigger: 'blur',
        },
      ],
    },

    {
      type: 'input',
      label: '小区',
      span: 8,
      display: true,
      size: 'small',
      prop: 'areaId',
      formslot: true,
      rules: [
        {
          required: true,
          message: '请选择小区',
          trigger: 'blur',
        },
      ],
    },
    {
      type: 'input',
      label: '反映类别',
      span: 8,
      display: true,
      size: 'small',
      prop: 'repairTypeId',
      rules: [
        {
          required: true,
          message: '请选择来源',
          trigger: 'blur',
        },
      ],
      formslot: true,
    },
    {
      type: 'datetime',
      label: '发生日期',
      span: 8,
      display: true,
      size: 'small',
      prop: 'repairTime',
      rules: [],
      required: false,
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
      disabled: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    },
    {
      type: 'select',
      label: '反映形式',
      span: 8,
      display: true,
      size: 'small',
      prop: 'form',
      dataType: 'number',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      dicUrl: '/api/blade-system/dict/dictionary?code=complaint_manage_type',
      clearable: true,
    },
    {
      span: 8,
      display: true,
      size: 'small',
      label: '反映来源',
      prop: 'source',
      type: 'select',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      dicUrl: '/api/blade-system/dict/dictionary?code=complaint_source',
      clearable: true,
      dataType: 'number',
    },
    {
      type: 'input',
      label: '反映内容',
      span: 16,
      display: true,
      size: 'small',
      prop: 'repairDesc',
      required: true,
      maxlength: 100,
      showWordLimit: true,
      formslot: true,
      rules: [
        {
          required: true,
          message: '反映内容必须填写',
        },
      ],
    },
    {
      label: '紧急程度',
      span: 8,
      display: true,
      size: 'small',
      prop: 'isExigency',
      type: 'select',
      dataType: 'number',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      dicUrl: '/api/blade-system/dict/dictionary?code=complaint_exigency',
      clearable: true,
      rules: [
        {
          required: true,
          message: '请选择紧急程度',
          trigger: 'blur',
        },
      ],
    },

    {
      label: '详细地址',
      span: 16,
      display: true,
      size: 'small',
      prop: 'address',
      formslot: true,
    },
    {
      type: 'input',
      label: '用户编号',
      span: 8,
      disabled: true,
      size: 'small',
      prop: 'appUser',
      maxlength: 100,
      showWordLimit: true,
    },
    {
      type: 'datetimerange',
      label: '预约时间',
      span: 16,
      display: true,
      size: 'small',
      prop: 'range',
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() <= new Date(new Date().toLocaleDateString()).getTime() - 1;
        },
      },
    },
    {
      type: 'textarea',
      label: '受理备注',
      span: 24,
      display: true,
      size: 'small',
      prop: 'remark1',
      maxlength: 200,
      showWordLimit: true,
    },
    {
      label: '文件上传',
      prop: 'accessoriesStr1or2',
      type: 'upload',
      span: 24,
      propsHttp: {
        res: 'data',
        url: 'link',
        name: 'originalName',
      },
      tip: '只能上传不超过5M的文件或图片',
      action: '/api/v4ward/oss/customEndpoint/put-file',
      dataType: 'string',
    },
  ],
};
